module.exports = __webpack_public_path__ + "static/Peace4b-593987d96aae51360b93985e3548b711.jpg";